import React, { useState, useEffect, useContext } from 'react';
import { translate, setLanguage, getLanguage } from 'react-multi-lang';
import { Menu, Select, Row, Col } from 'antd';
import {
  ApartmentOutlined,
  ContactsOutlined,
  FundProjectionScreenOutlined,
  HomeOutlined,
  PoweroffOutlined,
  SettingOutlined,
  SkinOutlined,
  TeamOutlined,
  UserOutlined,
  MobileOutlined,
} from '@ant-design/icons';

import { MenuTriatContext } from "../context/menu-triat";

import {ReactComponent as Botiga} from '../icons/icones_app_BSCD-01.svg';
import {ReactComponent as Serveis} from '../icons/icones_app_BSCD-02.svg';
import {ReactComponent as Dades} from '../icons/icones_app_BSCD-03.svg';
import {ReactComponent as Metge} from '../icons/icones_app_BSCD-07.svg';
import {ReactComponent as Documents} from '../icons/icones_app_BSCD-05.svg';
import {ReactComponent as Notificar} from '../icons/icones_app_BSCD-04.svg';
import {ReactComponent as Expedient} from '../icons/icones_app_BSCD-06.svg';
import {ReactComponent as Rebudes} from '../icons/icones_app_BSCD-08.svg';


const { SubMenu } = Menu;

function MenuLateral(props) {
  const [menuTriat, setMenuTriat] = useContext(MenuTriatContext);
  const [openKeys, setOpenKeys] = useState(['Dashboard']);

  // submenu keys of first level
  const rootSubmenuKeys = ['Dashboard','Pares_Botiga', 'Pares_Serveis', 'Pares_MevesDades', 'Pares_ServeiMedicArrel', 'Pares_Documents', 'Pares_Notificar', 'Pares_Expedient', 'Pares_NotificacionsRebudes', 'Pares_Configuracio'];

  useEffect(() => {
    if(menuTriat==='Dashboard'){
      setOpenKeys(['Dashboard']);
      document.getElementById("Dashboard").classList.add("ant-menu-item-selected");
      Array.from(document.getElementsByClassName('ant-menu-item-only-child ant-menu-item-selected')).forEach((el) => el.classList.remove('ant-menu-item-selected'));
    }else{
      document.getElementById("Dashboard").classList.remove("ant-menu-item-selected");
    }
  },[menuTriat]);


  const changeLang = (lang) =>{
      setLanguage(lang);
      sessionStorage.setItem('Language',lang);
    }

    const onOpenChange = openKeys_list => {
      const latestOpenKey = openKeys_list.find(key => openKeys.indexOf(key) === -1);
      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        setOpenKeys(openKeys_list);
      } else {
        setOpenKeys(latestOpenKey ? [latestOpenKey] : []);

      }
    };
    const triarMenu = (menuTriat) =>{
      setMenuTriat(menuTriat);
    }


    return (
      <Menu
        theme="light"
        className="MenuLateral"
        mode="inline"
        onClick={({key}) => triarMenu(key)}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        style={{ width: '100%', height: '100%', border: 'none' }}
        defaultSelectedKeys="Dashboard"
      >
        <Menu.Item key="Dashboard" className="MenuLateral" id="Dashboard">
          <span>
            <HomeOutlined />
            <span>{props.t('menu.inicio')}</span>
          </span>
        </Menu.Item>

          <div style={{paddingLeft:'24px'}}>
            <span>{props.t('generic.idioma')}:&nbsp;&nbsp;</span>
            <Select defaultValue={getLanguage()} onChange={changeLang} style={{ width: 110}} size="small">
              <Select.Option value="es">Castellano</Select.Option>
              <Select.Option value="ca">Català</Select.Option>
              <Select.Option value="en">English</Select.Option>
            </Select>
          </div>

        <Menu.Item key="Logout" className="MenuLateral">
          <span>
            <PoweroffOutlined />
            <span>{props.t('menu.cerrar_sesion')}</span>
          </span>
        </Menu.Item>
      </Menu>
    );
}

export default translate(MenuLateral);
